
import { defineComponent, ref, watchEffect } from 'vue';
import FileCaptionPair from '@/interface/FileCaptionPair';

export default defineComponent({
  props: {
    photoAreaId: {
      type: Number,
      required: true,
    },
    savePhotosToCollection: {
      type: Function,
      required: true,
    },
  },
  setup(props) {
    const caption = ref('');
    const files = ref([] as File[]);

    const getFiles = (e: Event) => {
      // @ts-ignore
      const fileList = e.target.files as FileList;
      files.value = Object.values(fileList);
    };

    watchEffect(() => {
      const pairs = files.value.map(file => {
        const pair: FileCaptionPair = { file, caption: caption.value };
        return pair;
      });
      props.savePhotosToCollection(props.photoAreaId, pairs);
    });

    return { caption, getFiles };
  },
});
